import { useCallback, type KeyboardEvent } from 'react'

import {
  type GlobalSearchTab,
  type GlobalSearchTabTypeEnum,
} from '../../enums/GlobalSearchTabTypeEnum'

export const useGlobalSearchResultTabsArrowNavigation = (
  tabs: GlobalSearchTab[],
  onSelect: (type: GlobalSearchTabTypeEnum) => void
) => {
  return useCallback(
    (e: KeyboardEvent<HTMLDivElement>) => {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return
      const radios = Array.from(
        e.currentTarget.querySelectorAll<HTMLButtonElement>('[role="radio"]')
      )
      e.preventDefault()
      const current = radios.indexOf(
        document.activeElement as HTMLButtonElement
      )
      if (current === -1) return
      const next =
        e.key === 'ArrowRight'
          ? (current + 1) % radios.length
          : (current - 1 + radios.length) % radios.length
      radios[next]?.focus()
      if (tabs[next]) onSelect(tabs[next].type)
    },
    [tabs, onSelect]
  )
}
